import { Box } from '@factorialco/deprecated-design-system'

import { CameraButton } from './components/CameraButton'
import { ChatButton } from './components/ChatButton'
import { DisconnectButton } from './components/DisconnectButton'
import { MicrophoneButton } from './components/MicrophoneButton'
import { ScreenShareButton } from './components/ScreenShareButton'
import { SettingsButton } from './components/SettingsButton'
import { SidebarButton } from './components/SidebarButton'

interface ControlBarProps {
  handleDisconnect: () => void
}

export const ControlBar = ({ handleDisconnect }: ControlBarProps) => {
  return (
    <Box flexDirection="row" gap="s8" alignItems="center" justifyContent="center">
      <MicrophoneButton />
      <CameraButton />
      <ScreenShareButton />

      <Box
        background="grey400"
        style={{
          width: '1px',
          height: '16px',
          margin: '0 8px',
        }}
        borderRadius={{ all: 'abs008' }}
      />

      <ChatButton />
      <SidebarButton />
      <SettingsButton />
      <DisconnectButton onDisconnect={handleDisconnect} />
    </Box>
  )
}
